// ─── Shared Constants ──────────────────────────────────────
// Colors, permissions, safety tables, styles

export const MD_PERMISSIONS = {
  create_edit_patients: true, define_protocols: true, assign_treatment: true,
  execute_session: true, view_session_history: true, input_outcome_scores: true,
  view_outcome_trends: true, amend_session_records: true, generate_reports: true,
  edit_report_narrative: true, manage_settings: true, export_research_data: true,
  create_edit_reminders: true, end_treatment: true,
};

export const DEFAULT_OPERATOR_PERMISSIONS = {
  create_edit_patients: true, define_protocols: false, assign_treatment: false,
  execute_session: true, view_session_history: true, input_outcome_scores: true,
  view_outcome_trends: true, amend_session_records: false, generate_reports: true,
  edit_report_narrative: false, manage_settings: false, export_research_data: false,
  create_edit_reminders: false, end_treatment: false,
};

export const PERMISSION_LABELS = {
  create_edit_patients: "Create / Edit Patients",
  define_protocols: "Define / Create Stimulation Protocols",
  assign_treatment: "Assign Treatment to Patient",
  execute_session: "Execute Treatment Session",
  view_session_history: "View Session History",
  input_outcome_scores: "Input / Edit Outcome Scores",
  view_outcome_trends: "View Outcome Trends / Graphs",
  amend_session_records: "Amend / Correct Session Records",
  generate_reports: "Generate Reports (Insurance & Provider)",
  edit_report_narrative: "Edit Report Narrative Before Sending",
  manage_settings: "Manage System Settings",
  export_research_data: "Export Research Data",
  create_edit_reminders: "Create / Edit Reminders",
  end_treatment: "End Treatment (Complete / End Early)",
};

export const COLORS = {
  bg: "#F0F2F5",
  surface: "#FFFFFF",
  primary: "#1B5E7B",
  primaryHover: "#164D65",
  primaryLight: "#E8F4F8",
  accent: "#2E9E6A",
  accentHover: "#258756",
  danger: "#C0392B",
  dangerLight: "#FDEDEC",
  dangerBorder: "#E6B0AA",
  warning: "#E67E22",
  warningLight: "#FDF2E9",
  warningBorder: "#F0C78A",
  text: "#1A1A2E",
  textSecondary: "#5A6178",
  border: "#D5D9E2",
  borderLight: "#E8EBF0",
  headerBg: "#1B5E7B",
  headerText: "#FFFFFF",
  tileBg1: "#1B5E7B",
  tileBg2: "#2E9E6A",
  tileBg3: "#6A3DB5",
  tileBg4: "#5A6178",
  badgeActive: "#2E9E6A",
  badgeCompleted: "#5A6178",
  badgeEndedEarly: "#C0392B",
  inputBg: "#F7F8FA",
};

export const baseStyles = {
  fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
};

export const DISABLED_BTN = { opacity: 0.4, cursor: "not-allowed" };

// Safety Table 3: Max safe train duration (seconds) for conventional rTMS
export const SAFETY_TABLE_3 = {
  1:   { 90: 1800, 100: 1800, 110: 1800, 120: 360, 130: 50 },
  5:   { 90: 10, 100: 10, 110: 10, 120: 10, 130: 10 },
  10:  { 90: 5, 100: 5, 110: 5, 120: 4.2, 130: 2.9 },
  20:  { 90: 2.05, 100: 2.05, 110: 1.6, 120: 1.0, 130: 0.55 },
  25:  { 90: 1.28, 100: 1.28, 110: 0.84, 120: 0.4, 130: 0.24 },
};
